var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"captchaContainer",attrs:{"id":"captchaContainer"}},[_c('VueTurnstile',{ref:"turnstileComponent",attrs:{"sitekey":_vm.sitekey,"theme":"light","size":"normal"},on:{"verify":_vm.verify}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }